import {
    GET_TRANSACTION_NUMBER_REQUEST,
    GET_TRANSACTION_NUMBER_SUCCESS,
    GET_TRANSACTION_NUMBER_ERROR,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_TRANSACTION_NUMBER_REQUEST:
            return {
                loading: true,
            };
        case GET_TRANSACTION_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_TRANSACTION_NUMBER_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}